import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { monitoringQueries } from '@/lib/queries/monitoring';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { DatadogApiCredentialsForm } from './-components/DatadogApiCredentialsForm';

export const Route = createFileRoute(
  '/_root/integrations/monitoring/datadog-api-credentials/$id',
)({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.editDatadogApiCredentials' }),
  }),
  loader: async ({ context, params: { id } }) => {
    const defaultProject = await preLoadDefaultProject({ context });
    await context.queryClient.ensureQueryData(
      monitoringQueries.datadogApiCredentialsDetail(defaultProject.id, id),
    );

    return defaultProject;
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const defaultProject = Route.useLoaderData();

  const { data: apiCredentials } = useSuspenseQuery(
    monitoringQueries.datadogApiCredentialsDetail(defaultProject.id, id),
  );

  return (
    <>
      <DatadogApiCredentialsForm
        mainProject={defaultProject}
        initialValue={apiCredentials}
      />
    </>
  );
}
